import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { AuthProvider } from "./contexts/AuthContext";
import { OrderProvider } from "./contexts/OrderContext";
import { ShippingProvider } from "./contexts/ShippingContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { HashRouter } from "react-router-dom";
import { DetectOfflineProvider } from "./contexts/DetectOfflineContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
      {/* <DetectOfflineProvider> */}
      <AuthProvider>
        <OrderProvider>
          <ShippingProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </ShippingProvider>
        </OrderProvider>
      </AuthProvider>
      {/* </DetectOfflineProvider> */}
    </HashRouter>
  </React.StrictMode>
);

// serviceWorkerRegistration.register();
